import { PrimaryNavKey } from './primary-nav-key';
import { PrimaryNavOption } from './primary-nav-option';

export class PrimaryNavOptions {
  private readonly optionsBacking: PrimaryNavOption[];

  get values() {
    return [...this.optionsBacking];
  }

  constructor(options: PrimaryNavOption[]) {
    this.optionsBacking = options.filter((option) => option.enabled);
  }

  get(key: PrimaryNavKey) {
    return this.optionsBacking.find((option) => option.key === key) ?? null;
  }
}
